/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithRevisionItemRequestBuilder, WithRevisionItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/pending/{fileId}/revisions
 */
export interface RevisionsRequestBuilder extends BaseRequestBuilder<RevisionsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.files.pending.item.revisions.item collection
     * @param revisionId Unique identifier of the item
     * @returns {WithRevisionItemRequestBuilder}
     */
     byRevisionId(revisionId: Guid) : WithRevisionItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const RevisionsRequestBuilderUriTemplate = "{+baseurl}/files/pending/{fileId}/revisions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RevisionsRequestBuilderNavigationMetadata: Record<Exclude<keyof RevisionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byRevisionId: {
        navigationMetadata: WithRevisionItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["revisionId"],
    },
};
/* tslint:enable */
/* eslint-enable */
